/* ============================================================
   artvision® · ART FINDER · Ergebnisseite
   Figma 503:3 ff.

   Die Antworten stehen in der Adresszeile, die Werke stehen im
   Shop. Diese Datei bringt beides zusammen: sie übersetzt die
   Antworten in Produktfilter und holt die Treffer über die
   Section Rendering API aus der Basiskollektion.

     /collections/<basis>?<filter…>&section_id=av-fnd-feed

   Damit gilt für den Art Finder exakt dieselbe Filterlogik wie
   für die Galerie — es gibt keine zweite Wahrheit.

   Drei Anfragen:
     exakt   alle Antworten          → 02 und 03
     weiter  ohne Budget und Präsenz → 04 Etwas mutiger
     offen   nur noch die Wirkung    → 05 Eine andere Richtung

   Die Zuordnung Antwort → Filterwert kommt aus der Konfiguration,
   die snippets/av-finder-data.liquid als JSON mitliefert. Wer
   eine Antwort ändert, ändert sie dort — nicht hier.
   ============================================================ */

(function () {
  'use strict';

  var root = document.querySelector('[data-av-result]');
  if (!root) return;

  var CFG = readConfig();
  if (!CFG) return;

  var base = root.getAttribute('data-base') || 'alle-werke';
  var SECTION = 'av-fnd-feed';

  /* Antworten, die nur Zusammenhang stiften und nie filtern. */
  var SOFT_KEYS = ['wall', 'context'];
  /* Fällt in "Etwas mutiger" weg. */
  var BOLD_DROP = ['budget', 'format'];
  /* Bleibt in "Eine andere Richtung" übrig. */
  var OTHER_KEEP = ['mood', 'room'];

  var els = {
    answers: root.querySelector('[data-av-res-answers]'),
    count: root.querySelector('[data-av-res-count]'),
    loading: root.querySelector('[data-av-res-loading]'),
    widened: root.querySelector('[data-av-res-widened]'),
    empty: root.querySelector('[data-av-res-empty]'),
    first: root.querySelector('[data-av-res-first]'),
    hero: root.querySelector('[data-av-res-hero]'),
    rows: {
      match: root.querySelector('[data-av-res-row="match"]'),
      bold: root.querySelector('[data-av-res-row="bold"]'),
      other: root.querySelector('[data-av-res-row="other"]')
    },
    grids: {
      match: root.querySelector('[data-av-res-grid="match"]'),
      bold: root.querySelector('[data-av-res-grid="bold"]'),
      other: root.querySelector('[data-av-res-grid="other"]')
    }
  };

  /* ---------- Konfiguration und Antworten ------------------ */

  function readConfig() {
    var tag = document.getElementById('AvFinderConfig');
    if (!tag) return null;
    try {
      return JSON.parse(tag.textContent);
    } catch (e) {
      return null;
    }
  }

  /* key → { filter, join, multi, options: { wert: {label, filters} } } */
  function groupIndex() {
    var map = {};
    (CFG.screens || []).forEach(function (screen) {
      (screen.groups || []).forEach(function (group) {
        var options = {};
        (group.options || []).forEach(function (option) {
          options[option.value] = {
            label: option.label,
            filters: (option.filters || []).filter(Boolean)
          };
        });
        map[group.key] = {
          filter: group.filter || '',
          join: group.join || 'oder',
          multi: !!group.multi,
          options: options
        };
      });
    });
    return map;
  }

  var GROUPS = groupIndex();

  function answersFromUrl() {
    var out = {};
    var params = new URLSearchParams(window.location.search);
    params.forEach(function (value, key) {
      if (!value) return;
      out[key] = value.split(',').filter(Boolean);
    });
    return out;
  }

  var ANSWERS = answersFromUrl();

  /* ---------- Antwortzeile ---------------------------------- */

  function paintAnswers() {
    if (!els.answers) return;
    var html = '';

    Object.keys(ANSWERS).forEach(function (key) {
      var group = GROUPS[key];
      ANSWERS[key].forEach(function (value) {
        var label = group && group.options[value] ? group.options[value].label : '';
        if (!label && key === 'wall') label = ANSWERS[key][0] + ' cm Wandbreite';
        if (!label) return;
        html += '<li class="av-fnd-res__answer">' + escapeHtml(label) + '</li>';
      });
    });

    els.answers.innerHTML = html;
  }

  function escapeHtml(text) {
    var box = document.createElement('div');
    box.textContent = text;
    return box.innerHTML;
  }

  /* ---------- Filter bauen ---------------------------------- */

  /* Eine Anfrage ist eine Liste aus [Parameter, Wert]. Ein
     Filter mit Verknüpfung 'einzeln' erzwingt mehrere Anfragen
     (Shopify schneidet dort mehrere Werte, statt sie zu addieren),
     deshalb liefert diese Funktion immer eine Liste von Anfragen. */
  function buildRequests(keys) {
    var requests = [[]];

    keys.forEach(function (key) {
      var group = GROUPS[key];
      if (!group || !group.filter) return;
      if (SOFT_KEYS.indexOf(key) !== -1) return;

      var values = ANSWERS[key] || [];
      var pairs = [];

      values.forEach(function (value) {
        var option = group.options[value];
        if (!option || !option.filters.length) return;

        option.filters.forEach(function (raw) {
          if (raw.indexOf('range:') === 0) {
            pairs = pairs.concat(rangePairs(group.filter, raw.slice(6)));
          } else {
            pairs.push([group.filter, raw]);
          }
        });
      });

      if (!pairs.length) return;

      if (group.join === 'einzeln' && pairs.length > 1) {
        var spread = [];
        requests.forEach(function (req) {
          pairs.forEach(function (pair) {
            spread.push(req.concat([pair]));
          });
        });
        requests = spread;
      } else {
        requests = requests.map(function (req) {
          return req.concat(pairs);
        });
      }
    });

    return requests;
  }

  /* 'range:min-max' — beim Preis kennt Shopify gte/lte, bei den
     Maßen liegen rund hundert Einzelwerte vor ("60x80"), aus denen
     die passenden eingesammelt werden. */
  function rangePairs(param, range) {
    var bounds = String(range).split('-');
    var min = parseFloat(bounds[0]) || 0;
    var max = bounds[1] === '' || bounds[1] == null ? Infinity : parseFloat(bounds[1]);

    if (param === 'filter.v.price') {
      var out = [[param + '.gte', String(min)]];
      if (isFinite(max)) out.push([param + '.lte', String(max)]);
      return out;
    }

    return FACETS.filter(function (value) {
      var size = longestSide(value);
      return size !== null && size >= min && size < max;
    }).map(function (value) {
      return [param, value];
    });
  }

  function longestSide(value) {
    var numbers = String(value).match(/\d+([.,]\d+)?/g);
    if (!numbers || !numbers.length) return null;
    return Math.max.apply(
      null,
      numbers.map(function (n) {
        return parseFloat(n.replace(',', '.'));
      })
    );
  }

  function toUrl(pairs) {
    var query = pairs
      .map(function (pair) {
        return encodeURIComponent(pair[0]) + '=' + encodeURIComponent(pair[1]);
      })
      .join('&');

    return (
      '/collections/' + encodeURIComponent(base) + '?section_id=' + SECTION + (query ? '&' + query : '')
    );
  }

  /* ---------- Holen ---------------------------------------- */

  var FACETS = [];

  function fetchFeed(pairs) {
    return fetch(toUrl(pairs), { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (response) {
        if (!response.ok) throw new Error('Feed ' + response.status);
        return response.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var feed = doc.querySelector('[data-av-feed]');
        if (!feed) return { count: 0, items: [], hero: null };

        return {
          count: parseInt(feed.getAttribute('data-count'), 10) || 0,
          items: Array.prototype.slice.call(feed.querySelectorAll('.av-fnd-feed__item')),
          hero: feed.querySelector('[data-av-feed-hero]'),
          facets: feed.querySelector('[data-av-feed-facets]')
        };
      })
      .catch(function () {
        return { count: 0, items: [], hero: null };
      });
  }

  /* Mehrere Anfragen einer Stufe zusammenlegen, Dopplungen raus. */
  function collect(requests) {
    return Promise.all(requests.map(fetchFeed)).then(function (results) {
      var seen = {};
      var items = [];
      var hero = null;
      var count = 0;

      results.forEach(function (result) {
        count = Math.max(count, result.count);
        if (!hero && result.hero) hero = result.hero;

        result.items.forEach(function (item) {
          var handle = item.getAttribute('data-handle');
          if (!handle || seen[handle]) return;
          seen[handle] = true;
          items.push(item);
        });
      });

      return { count: count, items: items, hero: hero };
    });
  }

  /* ---------- Darstellung ---------------------------------- */

  var used = {};

  function take(items, limit) {
    var out = [];
    items.forEach(function (item) {
      if (out.length >= limit) return;
      var handle = item.getAttribute('data-handle');
      if (used[handle]) return;
      used[handle] = true;
      out.push(item);
    });
    return out;
  }

  function fill(name, items) {
    var grid = els.grids[name];
    var row = els.rows[name];
    if (!grid || !row) return;

    if (!items.length) {
      row.hidden = true;
      return;
    }

    grid.innerHTML = '';
    items.forEach(function (item) {
      grid.appendChild(item);
    });
    row.hidden = false;
  }

  function adviceContext() {
    var search = window.location.search.replace(/^\?/, '');
    if (!search) return;

    Array.prototype.forEach.call(root.querySelectorAll('[data-av-res-advice]'), function (link) {
      var href = link.getAttribute('href') || '';
      link.setAttribute('href', href + (href.indexOf('?') === -1 ? '?' : '&') + search);
    });
  }

  /* ---------- Ablauf --------------------------------------- */

  function run() {
    paintAnswers();
    adviceContext();

    var keys = Object.keys(GROUPS);

    /* Erst die vorhandenen Maße holen — ohne sie lässt sich die
       Präsenz-Frage nicht auf echte Werte abbilden. */
    fetchFeed([])
      .then(function (result) {
        if (result.facets) {
          try {
            FACETS = JSON.parse(result.facets.textContent) || [];
          } catch (e) {
            FACETS = [];
          }
        }

        return collect(buildRequests(keys));
      })
      .then(function (exact) {
        var boldKeys = keys.filter(function (key) {
          return BOLD_DROP.indexOf(key) === -1;
        });

        return collect(buildRequests(boldKeys)).then(function (bold) {
          var otherKeys = keys.filter(function (key) {
            return OTHER_KEEP.indexOf(key) !== -1;
          });

          return collect(buildRequests(otherKeys)).then(function (other) {
            render(exact, bold, other);
          });
        });
      });
  }

  function render(exact, bold, other) {
    if (els.loading) els.loading.hidden = true;

    if (els.count) {
      els.count.textContent = exact.count
        ? exact.count + (exact.count === 1 ? ' Werk' : ' Werke')
        : '';
    }

    var hero = exact.hero || bold.hero;

    if (!exact.items.length && !bold.items.length) {
      if (els.empty) els.empty.hidden = false;
      return;
    }

    if (exact.count > 0 && exact.count < 5 && els.widened) els.widened.hidden = false;
    if (exact.count === 0 && els.widened) els.widened.hidden = false;

    if (hero && els.hero && els.first) {
      var handle = hero.getAttribute('data-handle');
      if (handle) used[handle] = true;
      els.hero.appendChild(hero);
      els.first.hidden = false;
    }

    fill('match', take(exact.items, 4));
    fill('bold', take(bold.items, 4));
    fill('other', take(other.items, 3));
  }

  run();
})();
